import { getYearsOfExperience, getFormattedYearsOfExperience } from "@/utils/dateUtils";

// Dynamische Werte, die über die Website verwendet werden können
export const dynamicValues = {
  yearsExp: getYearsOfExperience,
  formattedYears: getFormattedYearsOfExperience,
  currentYear: () => new Date().getFullYear(),
  lastUpdated: () => new Date().toLocaleDateString('de-DE')
};